import React, { Component } from "react";
import { connect } from "react-redux";
import PageContainer from "pages/container";

import historyImg from "./history.png";

class History extends Component {
  render() {
    return (
      <PageContainer
        className="history"
        title="History"
        subtitle="Previous TWL champions"
      >
        <img src={historyImg} alt="TWL History" />
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
});

export default connect(mapStateToProps)(History);



// WEBPACK FOOTER //
// ./src/pages/history/history.js